import { useState, useEffect } from "react";
import { getEnvironment } from "../functions/api";
import { environments } from "../enviroments";
import type { Environment } from "../components/core/types";

export const useEnvironment = (): Environment | null => {
  const [env, setEnv] = useState<Environment | null>(null);
  
  useEffect(() => {
    getEnvironment()
      .then((response) => {
        const envName = response.data as keyof typeof environments;
        setEnv(environments[envName] || environments.Development);
      })
      .catch(() => {
        setEnv(environments.Development);
      });
  }, []);
  
  return env;
};
